import {
  dbui_v1_OperationalAlert,
  dbuiV1GetOperationalAlertByIdOptions,
  dbuiV1GetOperationalAlertByIdQueryKey,
} from '@antimatterhq/asl-api-ts-v1';
import { useQueryClient } from '@tanstack/react-query';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { useWarehouseLocation } from '@/contexts/WarehouseLocationContext';
import { defaultOptions } from '@/utils/query';

export const useGetAlertById = ({ id }: { id: string }) => {
  const { workspace } = useWorkspace();
  const { selectedWarehouse } = useWarehouseLocation();
  const warehouse = selectedWarehouse?.id || '';

  return useQuery({
    ...dbuiV1GetOperationalAlertByIdOptions({
      ...defaultOptions(),
      path: {
        workspace,
        id,
      },
      query: { warehouse },
    }),
    enabled: Boolean(workspace) && Boolean(warehouse) && Boolean(id),
  });
};

export const useOptimisticUpdateAlertById = () => {
  const { workspace } = useWorkspace();
  const { selectedWarehouse } = useWarehouseLocation();
  const warehouse = selectedWarehouse?.id || '';

  const queryClient = useQueryClient();

  return ({ data }: { data: dbui_v1_OperationalAlert }) => {
    queryClient.setQueryData(
      dbuiV1GetOperationalAlertByIdQueryKey({
        ...defaultOptions(),
        path: {
          workspace,
          id: `${data.id}`,
        },
        query: {
          warehouse,
        },
      }),
      data,
    );
  };
};
